export const formatPrice = (price) => {
    if (price === null || price === undefined) {
        return null;
    }

    const options = {
        style: 'currency',
        currency: window.config.currency.code,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        useGrouping: true, // Enable thousands separator
        numberingSystem: 'latn' // Forces numbers to be displayed using Latin digits (0-9) instead of localized digits
    }

    return new Intl.NumberFormat(window.config.language.locale, options).format(Number(price));
};
